"use client";
import useTranslations from "@/i18n/useTranslations";

export default function Header() {
  const t = useTranslations("Course");
  return <h2 className="mb-0 mt-6 text-2xl">{t("getMoreInformation")}</h2>;
}
